import { Card, CardContent, CardHeader, Chip } from "@mui/material";
import type { WorkflowDiagramStep } from "../../../../../api/types/workflowTypes";
import WorkflowActivityCardContent from "./WorkflowActivityCardContent";
import WorkflowActivityTitle from "./WorkflowActivityTitle";
import WorkflowApprovalCardContent from "./WorkflowApprovalCardContent";
import WorkflowChannelCardTitle from "./WorkflowChannelCardTitle";
import WorkflowChannelsCardContent from "./WorkflowChannelsCardContent";

interface Props {
  step: WorkflowDiagramStep;
  headerRef?: React.Ref<HTMLDivElement>;
}

const WorkflowStepCard = ({ step, headerRef }: Props) => {
  return (
    <Card variant="outlined" sx={{ minWidth: "20rem", maxWidth: step.type === "Activity" ? "20rem" : undefined }}>
      <CardHeader
        title={
          <>
            {step.type === "Activity" && step.activity && <WorkflowActivityTitle activity={step.activity} />}
            {step.type === "InboxChannel" && <WorkflowChannelCardTitle />}
          </>
        }
        action={
          step.type === "Activity" &&
          step.activity?.isAiPowered && <Chip variant="outlined" color="secondary" label="AI" />
        }
        sx={(t) => ({ py: 1.5, borderBottom: `1px solid ${t.palette.divider}` })}
        ref={headerRef}
      />
      <CardContent sx={{ px: 1.5, py: 1.5 }}>
        <>
          {step.type === "Activity" && step.activity && step.activity.isApprovalActivity && (
            <WorkflowApprovalCardContent activity={step.activity} approvalConfiguration={step.approvalConfiguration} />
          )}
          {step.type === "Activity" && step.activity && !step.activity.isApprovalActivity && (
            <WorkflowActivityCardContent activity={step.activity} />
          )}
          {step.type === "InboxChannel" && step.inboxChannel && (
            <WorkflowChannelsCardContent inboxChannels={[step.inboxChannel]} />
          )}
        </>
      </CardContent>
    </Card>
  );
};

export default WorkflowStepCard;
